import { useTranslation } from "react-i18next";

import { BalanceLabelProps } from "./BalanceLabel.types";

import styles from "./BalanceLabel.module.scss";

const BalanceLabel = ({ balance, label }: BalanceLabelProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.balance}>
      <div className={styles.balance_title}>
        <span>{t(label)}:</span>
      </div>

      <div className={styles.balance_amount}>
        {balance ? balance?.toLocaleString("en-US") : "..."} FCFA
      </div>
    </div>
  );
};

export default BalanceLabel;
